<div class="bank-promotion" tabindex="0">
  <p
    class="bank-promotion__text"
    [ngStyle]="getTextStyles()"
    (touchstart)="onTouch($event)"
    #bankPromotion
  >
    {{
      promotionData.promotionFlag ? promotionData.promotionFlag : "Promotion"
    }}
    <span
      class="bank-promotion__tooltip"
      [class.mobile-active]="showMobileTooltip"
      *ngIf="
        promotionData.promotionHoverText || promotionData.promotionHoverHeader
      "
    >
      <span class="tooltip__content">
        <strong *ngIf="promotionData.promotionHoverHeader">{{
          promotionData.promotionHoverHeader
        }}</strong>
        <span *ngIf="promotionData.promotionHoverText">{{
          promotionData.promotionHoverText
        }}</span>
      </span>
    </span>
  </p>
  <div
    class="bank-promotion__backdrop"
    [class.mobile-active]="showMobileTooltip"
    (touchstart)="onTouch($event)"
  ></div>
</div>
